import React, { useState } from 'react'

import Checkbox from '../../../../../../App/Components/Checkbox/Checkbox'

import style from './style.scss'

type Props = {
  isMultipleChoice: boolean
  choices: string[]
}
export const ChoiceTypeField = ({ isMultipleChoice, choices }: Props) => {
  const [checked, setChecked] = useState<boolean[]>(
    Array(choices.length).fill(false),
  )

  const sortedChoices = choices.sort()

  const onCheckedChange = (index: number, isChecked: boolean) => {
    let newChecked = [...checked]
    if (!isMultipleChoice && isChecked) {
      newChecked = Array(choices.length).fill(false)
    }

    newChecked[index] = isChecked
    setChecked([...newChecked])
  }

  const choiceList = sortedChoices.map((choice, index) => {
    return (
      <div className={style.choiceQuestion} key={`choiceQuestion${index}`}>
        <Checkbox
          label={choice}
          onChange={isChecked => onCheckedChange(index, isChecked)}
          isChecked={checked[index]}
        />
      </div>
    )
  })

  return (
    <div className={style.choiceWrapper} key={'choiceContainer'}>
      {choiceList}
    </div>
  )
}
